import { AppBar, Paper, Tab, Tabs } from '@mui/material';
import { makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import TabPanel from '../misc/TabPanel';
import { Processo } from '../modelo';
import ImportacaoService from '../services/ImportacaoService';
import ImportacaoProcessosStore from '../store/ImportacaoProcessosStore';
import ViewDadosProcessoImportacao from './ViewDadosProcessoImportacao';
import { ViewPecasProcesso } from './escaninho/ViewPecasProcesso';

interface IPropsPainelExpandidoImportacao {
    processo: Processo;
}


class PainelExpandidoImportacao extends React.Component<IPropsPainelExpandidoImportacao> {
    constructor(props: IPropsPainelExpandidoImportacao) {
        super(props);

        makeObservable(this, {
});
    }

    get idProcesso() {
        return this.props.processo.identificadorProcesso;
    }

    render() {
        if (!ImportacaoProcessosStore.deveRenderizar(this.idProcesso)) {
            return null;
        }
        return (
            <div className="largura-100">
                <AppBar position="relative">
                    <Tabs
                        value={ImportacaoProcessosStore.abaSelecionada}
                        onChange={ImportacaoService.handleMudaAba}
                        indicatorColor="primary"
                    >
                        <Tab
                            style={{ color: 'white' }}
                            label="Geral"
                        // onClick={ImportacaoService.consultarDadosProcesso.bind(this, this.props.processo)}
                        />
                        <Tab
                            style={{ color: 'white' }}
                            label="Peças"
                        // onClick={this.consultarPecasProcesso}
                        />
                    </Tabs>
                </AppBar>
                <Paper
                    className="conteudoPaperImportacao"
                    variant="outlined"
                    elevation={0}
                >
                    <TabPanel
                        value={ImportacaoProcessosStore.abaSelecionada}
                        index={0}
                    >
                        <ViewDadosProcessoImportacao processo={this.props.processo} />
                    </TabPanel>
                    <TabPanel
                        value={ImportacaoProcessosStore.abaSelecionada}
                        index={1}
                    >
                        <ViewPecasProcesso pecas={this.props.processo.pecas} idProcesso={ImportacaoProcessosStore.idProcessoPainelExpandido} />
                    </TabPanel>
                </Paper>
            </div>
        );
    }
}

export default observer(PainelExpandidoImportacao);
